import * as Yup from 'yup';

import {
  CreateOfficeField,
  getOfficeFieldRequiredErrorMessage,
  getOfficeFieldWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateOfficeField) => {
  return Yup.string()
    .typeError(getOfficeFieldWrongTypeErrorMessage(fieldName))
    .required(getOfficeFieldRequiredErrorMessage())
    .trim()
    .min(1, getOfficeFieldWrongTypeErrorMessage(fieldName));
};
//
export const CreateOfficeFieldsSchema = Yup.object({
  [CreateOfficeField.AddressUuid]: Yup.string().optional().nullable(),
  [CreateOfficeField.Name]: stringRequired(CreateOfficeField.Name),
  [CreateOfficeField.OfficeUuid]: Yup.string().optional().nullable(),
  [CreateOfficeField.Street1]: stringRequired(CreateOfficeField.Street1),
  [CreateOfficeField.Street2]: Yup.string().optional().nullable(),
  [CreateOfficeField.City]: stringRequired(CreateOfficeField.City),
  [CreateOfficeField.RegionUuid]: stringRequired(CreateOfficeField.RegionUuid),
  [CreateOfficeField.PostalCode]: stringRequired(CreateOfficeField.PostalCode),
  [CreateOfficeField.CountryUuid]: stringRequired(
    CreateOfficeField.CountryUuid
  ),
});

export const CreateOfficeFieldsSchemaNoAddress = Yup.object({
  [CreateOfficeField.AddressUuid]: Yup.string().optional(),
  [CreateOfficeField.Name]: stringRequired(CreateOfficeField.Name),
  [CreateOfficeField.OfficeUuid]: Yup.string().optional(),
});
